import React from 'react'
import { Link } from 'react-router-dom'
import useBonusManager from '../../hooks/useBonusManager'
import ListItems from './ListItems'
import ILogo from '../../images/logo.png'
import IToken from '../../images/token.png'
import { NAME_TOKEN } from '../../constants'
import ModalStatus from '../../components/ModalStatus'
import { useModalStatus } from '../../hooks/useModalStatus'
import './style.scss'

const Bonus = () => {
  const {
    totalAvailable,
    totalBonus,
    transection,
    withDraw,
    hasBonus,
    dealDate,
  } = useBonusManager()

  const { modalStatusState, setCloseModalStatus } = useModalStatus()

  const { isShowModalStatus } = modalStatusState

  return (
    <div className='main-bonus'>
      {hasBonus ? (
        <div className='container'>
          <div className='card-bonus'>
            <div className='card-bonus--header'>
              <label className='text-header-bonus'>Bonus</label>
            </div>
            <div className='card-bonus--content'>
              <div className='content'>
                <div className='total-available-header'>
                  <label className='text-total-available'>
                    Total Available
                  </label>
                  <Link to='/swap' className='link-btn-more'>
                    <span className='btn secondary-btn outline-btn btn-more'>
                      BUY MORE
                    </span>
                  </Link>
                </div>
                <div className='total-available-box'>
                  <div className='wrap-content'>
                    <div className='wrap-total-available'>
                      <label className='label-total-available'>
                        {totalAvailable}
                      </label>
                    </div>
                    <div className='icon-token'>
                      <img className='img-token' alt='' src={IToken} />
                      <div className='text-token active'>{NAME_TOKEN}</div>
                    </div>
                  </div>
                  {dealDate.length == 0 ? (
                    <button
                      className='btn secondary-btn copy-btn'
                      onClick={withDraw}
                    >
                      Earn
                    </button>
                  ) : (
                    <label className='label-deal-date'>{dealDate}</label>
                  )}
                </div>
                <ListItems transection={transection} totalBonus={totalBonus} />
              </div>
              <div className='footer'></div>
            </div>
            <div className='footer'></div>
          </div>
        </div>
      ) : (
        <div className='container'>
          <div className='header header--bonus'>
            <h1 className='title title--bonus'>GET X3 BONUS</h1>
            <p className='sub-title sub-title--bonus'>
              Earn money by driving traffic and prompting sales across one of
              the world's best crypto
            </p>
            <Link to='/swap'>
              <div className='btn header--button active' onClick={() => {}}>
                GET One PIRATE
              </div>
            </Link>
          </div>
        </div>
      )}

      <ModalStatus
        modalStatus={isShowModalStatus}
        onCloseModal={setCloseModalStatus}
        onConfirm={() => {}}
      />
    </div>
  )
}

export default Bonus
